import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@mui/material/Grid2';

import SiteCard from './Card';
import SiteResources from './Resources';
import {
  StyledSubtab,
  StyledSubtabs,
} from '../../../../../components/StyledSubtabs';

export default function SitePage(props) {
  const { site } = props;
  const [tab, setTab] = useState(0);

  const handleChange = (e, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        <StyledSubtabs
          value={tab}
          onChange={handleChange}
          indicatorColor='primary'
          textColor='primary'
          variant='fullWidth'
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <StyledSubtab
            icon={<FontAwesomeIcon icon={['fal', 'building']} size='xl' />}
          />
          <StyledSubtab
            icon={<FontAwesomeIcon icon={['fal', 'sitemap']} size='xl' />}
          />
        </StyledSubtabs>
      </Grid>
      <Grid
        size={{ xs: 12 }}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          maxWidth: '100vw',
          px: 1,
        }}
      >
        {tab === 0 && <SiteCard site={site} />}
        {tab === 1 && <SiteResources site={site} />}
      </Grid>
    </>
  );
}
